/**
 * @Author: Junaid Atari junaid.attari@invozone.dev
 * @Date: 2025-02-17 16:54:27
 */

// clients
import ApiClient from '~/client/ApiClient';

// classes
import FormFieldsManager, {DeleteOnComplete, FormFieldsManagerInstance} from '~/classes/FormFieldsManager';

// utils
import {fields, PostcardFields} from './fields-info';

/**
 * Fetches the form fields data from the API.
 * @param apiClient - The API client instance.
 * @param [onComplete] - The callback function to be called when the request responses are fetched.
 * @returns The form fields data.
 */
export const fetchFieldsData = async (
  apiClient: InstanceType<typeof ApiClient>,
  onComplete: DeleteOnComplete | undefined = undefined,
): Promise<FormFieldsManagerInstance> => {
  const manager = new FormFieldsManager<PostcardFields>(apiClient, 'send-postcard', fields);
  await manager.fetchData();

  manager.initializeFields();

  onComplete?.call?.(null, manager.getResponses());
  return manager;
};
